// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IFXg","label":"styles_label__Hk-1o"};